type GraphqlRequestBodyExtras = {
  variables: Record<string, unknown> | null;
  extensions: Record<string, unknown> | null;
};

function isNonEmptyJsonObject(
  value: unknown,
): value is Record<string, unknown> {
  return (
    value !== null &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    Object.keys(value).length > 0
  );
}

function parseNonEmptyJsonObject(
  value: string,
): Record<string, unknown> | null {
  try {
    const parsed: unknown = JSON.parse(value);
    return isNonEmptyJsonObject(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function parseGraphqlRequestBodyExtras(
  bodySchema: string,
): GraphqlRequestBodyExtras {
  let parsed: { variablesString?: string; extensionsString?: string };

  try {
    parsed = JSON.parse(bodySchema) as {
      variablesString?: string;
      extensionsString?: string;
    };
  } catch {
    return { variables: null, extensions: null };
  }

  const variables =
    typeof parsed.variablesString === 'string'
      ? parseNonEmptyJsonObject(parsed.variablesString)
      : null;
  const extensions =
    typeof parsed.extensionsString === 'string'
      ? parseNonEmptyJsonObject(parsed.extensionsString)
      : null;

  return { variables, extensions };
}

export function formatEndpointBodySchema(
  bodySchema: string | null | undefined,
): {
  content: string;
  language: string | null;
} {
  if (!bodySchema) {
    return { content: '', language: null };
  }

  try {
    const parsed = JSON.parse(bodySchema) as { documentString?: string };
    if (typeof parsed.documentString === 'string') {
      return { content: parsed.documentString, language: 'graphql' };
    }

    return {
      content: JSON.stringify(parsed, null, 2),
      language: 'json',
    };
  } catch {
    return { content: bodySchema, language: null };
  }
}
